var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMusic = function SvgMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.914 11.429a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4M0 12.629a2.914 2.914 0 1 1 5.829 0 2.914 2.914 0 0 1-5.829 0M11.714 10.057a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m-2.914 1.2a2.914 2.914 0 1 1 5.828 0 2.914 2.914 0 0 1-5.828 0M15.486 19.086a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4m-2.915 1.2a2.914 2.914 0 1 1 5.829 0 2.914 2.914 0 0 1-5.829 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.106 1.257a.857.857 0 0 1 .837.877l-.229 9.829A.857.857 0 1 1 4 11.923l.229-9.829a.857.857 0 0 1 .877-.837",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.62.734a.857.857 0 0 1-.726.972L5.208 2.963a.857.857 0 1 1-.245-1.697L13.649.01a.857.857 0 0 1 .97.725",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M13.771 0c.474 0 .857.384.857.857v10.286a.857.857 0 0 1-1.714 0V.857c0-.473.384-.857.857-.857",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.276 4.042a.857.857 0 0 1-.718.977L5.329 6.276a.857.857 0 0 1-.258-1.695l8.228-1.257a.857.857 0 0 1 .977.718M17.429 9.486c.473 0 .857.384.857.857V19.6a.857.857 0 1 1-1.715 0v-9.257c0-.473.384-.857.857-.857",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.76 9.288a.857.857 0 0 1-.705.986l-5.486.914a.857.857 0 1 1-.281-1.69l5.485-.915a.857.857 0 0 1 .987.705M23.99 12.95a.857.857 0 0 1-.712.982l-5.714.914a.857.857 0 1 1-.27-1.692l5.713-.915a.857.857 0 0 1 .982.711",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M23.143 8.571c.473 0 .857.384.857.858v3.657a.857.857 0 0 1-1.714 0V9.429c0-.474.383-.858.857-.858",
    clipRule: "evenodd"
  })));
};
export default SvgMusic;